// This function can override the customElement decorator from lit.
// According to lit documentation, the decorator is a shorthand for document.define(), so we can call it ourselves here.
// Prevent content elements from being rendered if the tag-name is already taken. (which can happen in print to override components)
export function customElement(tag: string) {
  return (target: CustomElementConstructor) => {
    if (!customElements.get(tag)) {
      customElements.define(tag, target);
    }
  };
}
